import axios from '@dap/shared-utils/http.js';

const defaultConfig = {
    headers: { 'Content-Type': 'application/json' },
};
const BASE_URL = '/dapper/api/demand_socumentary';

export default {
    // 字典
    getDict () {
        return axios.get(`${BASE_URL}/data_dict`);
    },
    // 需求列表
    getList (params) {
        return axios.get(BASE_URL, { params });
    },
    // 脚本详情
    getDetail (id) {
        return axios.get(`${BASE_URL}/detail?id=${id}`);
    },
    getComments (params) {
        return axios.get('/dapper/api/demand_socumentary/comments', { params });
    },
    // 认领
    claim (params, isEdit) {
        let req = axios.post;
        if (isEdit) {
            req = axios.put;
            params.id = params.ids;
            delete params.ids;
        }
        return req(`${BASE_URL}/claim`, params, defaultConfig);
    },
    // 发包
    send (params, isEdit) {
        let req = axios.post;
        if (isEdit) {
            req = axios.put;
            params.id = params.ids;
            delete params.ids;
        }
        return req(`${BASE_URL}/outsourcing`, params, defaultConfig);
    },
    // 排期
    arrange (params, isEdit) {
        let req = axios.post;
        if (isEdit) {
            req = axios.put;
        }
        return req(`${BASE_URL}/schedule`, params, defaultConfig);
    },
    addDemand (params) {
        return axios.post(BASE_URL, params, defaultConfig);
    },
    // 新建/编辑
    editDemand (params) {
        return axios.put(BASE_URL, { ...params, is_draft: 0 }, defaultConfig);
    },
    // 保存草稿
    editDraft (params) {
        return axios.put(BASE_URL, { ...params, is_draft: 1 }, defaultConfig);
    },
    // 删除需求
    deleteDemand (params) {
        return axios.delete(BASE_URL, { params });
    },
    // 评论
    getComment (params) {
        return axios.get(`${BASE_URL}/comments`, { params });
    },
    deleteComment (params) {
        return axios.delete(`${BASE_URL}/comments`, { params });
    },
    addComment (params) {
        return axios.post(`${BASE_URL}/comments`, params, defaultConfig);
    },
    // 下载脚本
    downloadScript (params) {
        return axios.get(`${BASE_URL}/download`, { params });
    },
    // 上传附件
    upload (params) {
        return axios.post(`${BASE_URL}/upload`, params, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    // 脚本评审
    audit (params) {
        if (params.script_review_id) {
            return axios.put(`${BASE_URL}/review`, params, defaultConfig);
        }
        return axios.post(`${BASE_URL}/review`, params, defaultConfig);
    },
};
